<!-- <nav class="navbar navbar-expand-lg bg-body-tertiary">
  <div class="container-fluid">
    <div class="navbar-collapse">
      <div class="navbar-nav row">
        <div class="pull-left col-md-8">
        <a class="navbar-brand" routerLink="/user/dashboard" ><i class="fa fa-home"></i></a>
        <a class="nav-link" *ngIf="showMenu" href="#">Booking</a>
        <a class="nav-link" *ngIf="showMenu" href="#">Donation</a>
        <a class="nav-link" *ngIf="showMenu" href="#">Poojan Packages</a>
        <a class="nav-link" *ngIf="showMenu" href="#">Pricing</a>
      </div>
        <div class="account pull-right col-md-4 d-flex">
          <span>Welcome {{GuestName}}</span>
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              <i class="fa fa-circle-user"></i>
            </a>
            <ul class="dropdown-menu">
              <li><a class="dropdown-item" href="#">Action</a></li>
              <li><a class="dropdown-item" href="#">Another action</a></li>
              <li><a class="dropdown-item" href="#">Something else here</a></li>
            </ul>
          </li>
        </div>
      </div>
    </div>
  </div>
</nav> -->

<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <div class="container-fluid">
    <a class="navbar-brand pl-2" routerLink="/user/dashboard"><i class="fa fa-home" style="font-size: 20px;"></i></a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0 col-md-8" *ngIf="showMenu">
        <li class="nav-item">
          <a class="nav-link" aria-current="page" routerLink="/user/accommodation" routerLinkActive="active">Accommodation</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/user/donation" routerLinkActive="active">Donation</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/user/poojan" routerLinkActive="active">Poojan Package</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/user/vehicle-passes" routerLinkActive="active">Vehicle Pass</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/user/prasad" routerLinkActive="active">Prasad &amp; Souvenir</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="/user/transaction-history" routerLinkActive="active">Transaction History</a>
        </li>
      </ul>
      <div class="col-md-4 pull-right">
        <span class="username">Welcome {{GuestName}}</span>
        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown"
          aria-expanded="false">
          <i class="fa fa-circle-user"></i>
        </a>
        <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
          <li><a class="dropdown-item" routerLink="/user/myprofile">My Profile</a></li>
          <!-- <li><a class="dropdown-item">Change Password</a></li> -->
          <li><a class="dropdown-item" (click)="LogOut()">Logout</a></li>
        </ul>
      </div>
    </div>
  </div>
</nav>